export const reviews = [
  {
    id: 1,
    name: "Jake Fraser",
    image: "/assets/images/reviews/person-1.webp",
    description:
      "Clear Choice Cleaning Services has been my go-to for over a year. They always leave my home spotless. The staff is friendly, punctual, and thorough, especially in the kitchen and bathrooms. Highly recommend!",
    rating: 5,
    platform: "google",
  },
  {
    id: 2,
    name: "Ava Martin",
    image: "/assets/images/reviews/person-2.webp",
    description:
      "I’ve been using Clear Choice for months now. They are reliable, and my house always looks perfect after their visits. Friendly staff and great attention to detail. Highly recommend!",
    rating: 5,
    platform: "facebook",
  },
  {
    id: 3,
    name: "Jessie Wilson",
    image: "/assets/images/reviews/person-3.webp",
    description:
      "Clear Choice Cleaning Services made my move-out cleaning stress-free. The place was spotless, and I got my deposit back without any issues. Professional and efficient service!",
    rating: 5,
    platform: "google",
  },
  {
    id: 4,
    name: "Emily Johnson",
    image: "/assets/images/reviews/person-4.webp",
    description:
      "Clear Choice Cleaning Services has transformed our office over the past six months. They are reliable, professional, and efficient, making our workspace much cleaner and improving productivity. Fantastic service!",
    rating: 5,
    platform: "google",
  },
  {
    id: 5,
    name: "Rahul Malhotra",
    image: "/assets/images/reviews/person-5.webp",
    description:
      "I hired Clear Choice for a move-out clean, and they were amazing. The apartment was spotless, and I got my full deposit back. The team was quick and professional. Will use them again!",
    rating: 5,
    platform: "instagram",
  },
  {
    id: 6,
    name: "Olivia Wilson",
    image: "/assets/images/reviews/person-6.webp",
    description:
      "Clear Choice did a deep clean for my home, and I’m thrilled. They were meticulous and didn’t miss a spot. Everything feels fresh and clean, and I love their eco-friendly products. Highly satisfied!",
    rating: 5,
    platform: "facebook",
  },
  {
    id: 7,
    name: "David Thompson",
    image: "/assets/images/reviews/person-7.webp",
    description:
      "Clear Choice cleaned my carpets, and they look brand new. They removed stubborn stains that others couldn’t. The technicians were polite, efficient, and the price was great. Very happy with the results!",
    rating: 5,
    platform: "google",
  },
  {
    id: 8,
    name: "Mitchell Harris",
    image: "/assets/images/reviews/person-8.webp",
    description:
      "Clear Choice Cleaning Services did a fantastic job with our home cleaning. They were very thorough and left no stone unturned. Highly recommend their services for a spotless home!",
    rating: 5,
    platform: "instagram",
  },
];
